import { useState } from "react";
import { Check, ChevronsUpDown, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { brl } from "@/lib/api";

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const RecipeCombobox = ({ recipes, value, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const sel = recipes.find((r) => r.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" aria-expanded={open} data-testid={testId} className="w-full justify-between font-normal h-10 px-3">
          <span className="truncate flex items-center gap-2">{sel ? sel.name : <><Search className="w-4 h-4 text-muted-foreground" /><span className="text-muted-foreground">Pesquisar produto...</span></>}</span>
          <ChevronsUpDown className="w-4 h-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[280px]" align="start">
        <Command filter={(v, s) => (norm(v).includes(norm(s)) ? 1 : 0)}>
          <CommandInput placeholder="Digite para pesquisar..." data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>Nenhum produto encontrado.</CommandEmpty>
            <CommandGroup>
              {recipes.map((r) => (
                <CommandItem key={r.id} value={`${r.name} ${r.category || ""}`} onSelect={() => { onChange(r.id); setOpen(false); }} data-testid={`${testId}-option-${r.id}`}>
                  <Check className={`mr-2 h-4 w-4 ${r.id === value ? "opacity-100" : "opacity-0"}`} />
                  <span className="flex-1 truncate">{r.name}</span>
                  <span className="num text-xs text-muted-foreground ml-2">{brl(r.cost_per_portion)}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
